import { Observable } from "rxjs"
import CheckPoolMember from "./RandomsModel/CheckPoolMember"
import { PoolCompanyInfo } from "./RandomsModel/PoolCompanyInfo"
import PoolMemberData from "./RandomsModel/PoolMemberData"
import { ObservableFromFetch } from "../ObservableFromFetch"

export function PoolMemberCheck(poolId: number, accountType: string, mask: string, searchBy: string): Observable<CheckPoolMember> {
  const params: string = JSON.stringify({
    PoolId: poolId,
    AccountType: accountType,
    Mask: mask,
    SearchBy: searchBy
  })

  return ObservableFromFetch<CheckPoolMember>("/WorkforceRandomTest/CheckPoolMember", params)
}

export function PoolCompanyInfoGet(poolId: number): Observable<PoolCompanyInfo> {
  const params: string = JSON.stringify({
    PoolId: poolId
  })

  return ObservableFromFetch<PoolCompanyInfo>("/RandomTest/GetCompanyByPoolID", params)
}

export function PoolMemberAdd(data: PoolMemberData): Observable<string> {
  const params: string = JSON.stringify(data)

  return ObservableFromFetch<string>("/RandomTest/AddPerson", params)
}



